import axios from 'axios';
import config from 'api/urls-config.json';
import { API } from 'api/constants';

export const getPricing = () => {
    return axios.get(API + config.pages.pricing);
};

export const getProductsData = () => {
    return axios.get('https://development.api.private.user.pingproxies.com/1.0/private/user/product/stock');
};
